import React from 'react';
import { CloseOutlined, MinusOutlined } from '@ant-design/icons';
import logo from '../../assets/logo.png';

const ChatHeader = ({ onClose, onMinimize }) => {
  return (
    <div className="chat-header">
      <div className="chat-header-info">
        <div className="chat-header-text">
          <h3><img src={logo} alt="Parafly Travel" className="chat-header-logo" />Seyahat Danışmanı</h3>
          <span>
            <span className="chat-header-status-dot" />
            Çevrimiçi • Yardıma hazırız
          </span>
        </div>
      </div>
      <div className="chat-header-actions">
        <button className="chat-header-btn" onClick={onMinimize} aria-label="Küçült">
          <MinusOutlined />
        </button>
        <button className="chat-header-btn" onClick={onClose} aria-label="Kapat">
          <CloseOutlined />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
